import { Pipe, PipeTransform } from '@angular/core';
import { VideoYoutube } from '@components/video-youtube/models';
import { Image } from '@shared/components/image/models';
import { Video } from '@shared/components/video/models';

@Pipe({
  name: 'isImage',
  standalone: true,
})
export class IsImagePipe implements PipeTransform {
  transform(media: Image | Video | VideoYoutube): media is Image {
    return 'gravity' in media;
  }
}
